<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-home</v-icon>
      Make a Selection:
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" class="subtitle-1 text-center">
          On this landing page you will find the most common shortcuts. For a further list of resources click on <router-link to="/More" class="accent--text">Other Church Forms</router-link>
        </v-col>
      </v-row>
      <v-row align="start" justify="center">
        <v-card height="200px" width="200px" v-for="navItem in getNav" :key="navItem.item" class="ma-5 pa-5" outlined ripple :to="navItem.link" hover>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-container fluid fill-height v-on="on">
                <v-row align="center" justify="center" class="text-center">
                  <v-col align-items="center" class="subtitle-1">
                    <v-icon>{{navItem.icon}}</v-icon>
                    <br>
                    {{navItem.item}}
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <span>{{navItem.description}}</span>
          </v-tooltip>
        </v-card>
      </v-row>
      <v-row align="start" justify="center" v-if="getUser != null && getUserStatus">
        <v-card height="200px" width="200px" color="grey lighten-3" class="ma-5 pa-5" outlined ripple to="/Admin">
          <v-container fluid fill-height>
            <v-row align="center" justify="center" class="text-center">
              <v-col align-items="center" class="subtitle-1">
                <v-icon>fas fa-users-cog</v-icon>
                <br>
                Admin Toolbox
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import mixins from '@/plugins/mixins.js'
export default {
  mixins: [mixins],
  computed: {
    getNav(){
      return this.$store.getters.getNav.filter(item => {
        return item.item != "Home"
      })
    },
    getUser(){
      return this.$store.getters.getUser
    },
    getUserStatus(){
      let usr = this.getUser
      let allUsers = this.$store.getters.getUserList
      return allUsers.filter(user => user.email == usr)[0].status
    }
  }
}
</script>
